export default Object.freeze({
  ApplicationFileTypes: {
    CV: 1,
    Letter: 2,
    Image: 3,
    Document: 4,
    Photo: 5
  }
});
